export default {
    modalQuickActionVariations: {
        title: 'IA ',
        generateWithAi: "Générer avec l'IA",
        improveWriting: "Améliorer l'écriture",
        fixSpelling: "Corriger l'orthographe et la grammaire",
        simplifyWriting: "Simplifier l'écriture",
        makeLonger: 'Rendre plus long',
        makeShorter: 'Raccourcir',
        replaceText: 'Remplacer le texte',
        addBelow: 'Ajouter ci-dessous',
        cancel: 'Annuler',
        selectQuickActionTitle: "Dites à l'IA ce qu'elle doit faire ensuite...",
        regenerate: 'Régénérer',
    },
};
